<script setup lang="ts">
import Alert from '~/components/Alert.vue'
import BaseClipboard from '~/components/BaseClipboard.vue'

defineProps<{
  yaml?: string
  customDescription?: string
  showRuleNameWarning: boolean
}>()
</script>

<template>
  <div>
    <div v-if="customDescription" class="tw:mb-4">
      {{ customDescription }}
    </div>
    <div class="tw:font-semibold">
      YAML
    </div>
    <Alert v-if="showRuleNameWarning" variant="warning" class="tw:mt-4">
      ⚠️ Beware! You have this automation installed, if you use the following
      YAML to create a custom automation, make sure you change the rule name to
      prevent clashes.
    </Alert>
    <BaseClipboard :text="yaml ?? ''" :whitespace-pre="true" />
  </div>
</template>
